enum LetterStatus {
  Right = "0",
  Wrong = "1",
  PartiallyRight = "2",
  Typing = "3"
}

export default LetterStatus
